
//Base colors
export const themeColors = {
  primaryBlue: '#2A7CED',
  errorRed: '#EF4444',
  backgroundwhite: '#ffffff',
};

// Base styles
const baseFont = {
  fontFamily: "'Poppins', sans-serif",
};

const formHeaderStyles = {
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  fontSize: "14px",
  fontWeight: 500,
  marginBottom: "8px",
  display: "block",
  color: "#324054"
};

const inputStyles = {
  width: "100%",
  padding: "8px 12px",
  borderRadius: "2px",
  border: "1px solid #e5e7eb",
  fontSize: "14px",
};

const buttonStyles = {
  padding: "10px 16px",
  borderRadius: "4px",
  fontWeight: 500,
  cursor: "pointer",
  fontSize: "14px",
};

const modalFooterStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  padding: "16px",
};
const useStyleClasses = (isMobile=false) => {
  return ({
    baseFont: baseFont,
    formHeader: { ...baseFont, ...formHeaderStyles },
    label: { ...baseFont, ...labelStyles },
    input: { ...baseFont, ...inputStyles },
    button: { ...baseFont, ...buttonStyles },
    buttonBack: {
      ...baseFont, ...buttonStyles,
      backgroundColor: themeColors.backgroundwhite ,
      border: "1px solid #324054",
      color: "#324054",
      width: "110px"
    },
    buttonSubmit: {
      ...baseFont, ...buttonStyles,
      backgroundColor: themeColors.primaryBlue,
      border: "1px solid #2A7CED",
      color: themeColors.backgroundwhite,
      width: "110px",
      minWidth: "max-content",
    },
    accordionToggle:{
      ...baseFont,
      backgroundColor: "none",
      border: "none",
      color: "#324054",
      fontSize: "18px",
      cursor: "pointer",
    },
    buttonEndContainer:{
      flexShrink: 0,
      padding: "10px 10px",
      display: "flex",
      justifyContent: "flex-end", 
      gap: "14px",
    },
    fieldsetStyle:{
      border: "none",
      minWidth: 0,
      boxSizing: "border-box",
    },
    errorText: {
      ...baseFont,
      color: themeColors.errorRed,
      fontSize: '12px',
      marginTop: '4px',
      display: 'block',

    },
    disabledContainer:{
      pointerEvents: "none",  /* Block clicks */
      opacity: "0.5",           /* Gray out */
      userSelect: "none",  /* Prevent text selection */
      filter: "grayscale(100%)"/* Optional: desaturate */
    },
    countBox:{
      cursor: "pointer", 
      color: "#007bff" , 
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace:"nowrap",
      flex: "1 1 calc(33.333% - 8px)",
      minWidth: 0,
      textAlign: "center"
    },
    modalFooterStyle:modalFooterStyle,
    kitLayout:{
      display: "flex",
      gap: "5px",
      backgroundColor: "#f8fafc",
      height: "530px",
      position:"relative",
      flexDirection: isMobile ? "column" : "row",
      
    },
    kitLeftPanel:{
        width: isMobile?"100%":"60%",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        maxHeight: isMobile ? "none" : "calc(100vh - 48px)",
        overflowY: isMobile ? "visible" : "auto",
        padding: isMobile ? "8px" : "32px",
        border: "1px solid #E2E5ED",
        borderRadius: "4px"
      },
    kitRightPanel:
      {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        flex: isMobile ? "0 0 auto" : "1 1 0%",
        width: isMobile ? "100%" : "auto",
        minWidth: isMobile ? "200px" : "220px", // IMPORTANT
        padding: isMobile ? "16px" : "24px",
        border: "1px solid #E2E5ED",
        borderRadius: "4px",

      },

 historyContainerStyle: {
  backgroundColor: "white",
  borderRadius: "6px",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  overflowY: "auto",
  maxHeight: isMobile ? "unset" : "250px", // let it expand on mobile (optional)
},
historyHeaderStyle:{
  display: isMobile ? "none" : "grid", // hide header on mobile
  gridTemplateColumns: "1fr 1fr 1fr 1fr", // FIX: 4 columns
  gap: 0,
  padding: "8px 14px",
  backgroundColor: "#E2E5ED",
  borderTop: "1px solid #E2E5ED",
  borderBottom: "1px solid #E2E5ED",
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  position: "sticky",
  top: 0,
  zIndex: 1,
},
historyRowStyle :{
  display: isMobile ? "flex" : "grid",
  flexDirection: isMobile ? "column" : undefined,
  gridTemplateColumns: isMobile ? undefined : "1fr 1fr 1fr 1fr",
  gap: isMobile ? "6px" : 0,
  padding: isMobile ? "12px 14px" : "10px 18px",
  borderBottom: "1px solid #E2E5ED",
},
mobileFieldStyle: {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
},
mobileLabelStyle: {
  fontSize: "11px",
  color: "#868DAA",
  fontWeight: 500,
},
 valueStyle:  {
  fontSize: "12px",
  color: "#324054",
  fontWeight: 400,
},
tableDataRow:{ fontSize: "14px", color: "#324054", fontWeight: 400, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
tableCellSpan :{
    width: "90%",
    overflow : "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
},
    tableHeaderStyle: {
      backgroundColor: "#f8f9fa",
      fontWeight: 600,
      padding: "12px 8px",
      textAlign: "left",
      borderBottom: "2px solid #dee2e6",
      fontSize: "16px",
      color: "#324054",
    }
    , tableCellStyle: {
      padding: "12px 8px",
      borderBottom: "1px solid #dee2e6",
      fontSize: "13px",
      color: "#212529",
      verticalAlign: "top",
    }
    , linkStyle: {
      color: "#2A7CED",
      textDecoration: "underline",
      cursor: "pointer",
    }
    , typeStyle: {
      fontSize: "12px",
      fontWeight: 500,
      color: "#6c757d",
    }
    , tableStyle: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "white",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      border: "1px solid #dee2e6",
    }
    , tableContainerStyle: { 
      overflowX: "auto", 
      border: "1px solid #dee2e6", 
      borderRadius: 4 
    }
    , rowBaseStyle: {
      transition: "background-color 120ms ease",
    }
    , pagerWrapStyle: {
      marginTop: 16,
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
    }
    , pagerBtnStyle: {
      minWidth: isMobile?30:40,
      height: 32,
      padding: "0 10px",
      border: "1px solid #e0e0e0",
      background: "#f3f3f3",
      color: "#777",
      borderRadius: 2,
      cursor: "pointer",
      fontSize: 14,
    }
    , pagerBtnDisabled: {
      opacity: 0.6,
      cursor: "not-allowed",
    }
    , pageNumberStyle: {
      minWidth: isMobile?25: 36,
      height: 32,
      padding: isMobile?"0 5px":"0 10px",
      border: "1px solid #e0e0e0",
      background: "#2A7CED",
      color: "white",
      borderRadius: 2,
      cursor: "pointer",
      fontSize: 14,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    }
    , pageNumberActive: {
      background: "#6e7f87",
      color: "#fff",
      fontWeight: 700,
    }
    , pageEllipsisStyle: {
      padding: "0 4px",
      color: "#666",
      userSelect: "none",
    }
  }
  )
};
export default useStyleClasses;


const TABLE_MIN_WIDTH = "500px"; // prevents columns collapsing on mobile

const tableScrollWrapper = {
  overflowX: "auto",
  WebkitOverflowScrolling: "touch",
  borderRadius: "6px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  backgroundColor: "white",
};

const tableHeaderRow = (cols) => ({
  display: "grid",
  gridTemplateColumns: cols,
  gap: "0",
  padding: "10px 18px",
  backgroundColor: "#E2E5ED",
  borderTop: "1px solid #E2E5ED",
  borderBottom: "1px solid #E2E5ED",
  borderTopLeftRadius: "6px",
  borderTopRightRadius: "6px",
  minWidth: TABLE_MIN_WIDTH,
  // Sticky header inside scroll container
  position: "sticky",
  top: 0,
  zIndex: 1,
});

const tableDataRow = (cols, index, total) => ({
  display: "grid",
  gridTemplateColumns: cols,
  gap: "0",
  padding: "10px 18px",
  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
  borderBottom: index < total - 1 ? "1px solid #E2E5ED" : "none",
  minWidth: TABLE_MIN_WIDTH,
});

const headerCell = {
  fontSize: "14px",
  fontWeight: 500,
  color: "#324054",
  whiteSpace: "nowrap",
};

const dataCell = {
  fontSize: "14px",
  color: "#324054",
  fontWeight: 400,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};